import type { SVGProps } from "react";
import { cn } from "@/lib/utils";
const GLYPH_PATHS = {
  chevronLeft: "M10 3.5 5.5 8l4.5 4.5",
  chevronRight: "M6 3.5 10.5 8 6 12.5",
  chevronUp: "M3.5 10 8 5.5l4.5 4.5",
  chevronDown: "M3.5 6 8 10.5 12.5 6",
  chevronsUpDown: "M5 6l3-3 3 3M5 10l3 3 3-3",
  arrowLeft: "M13 8H3m4-4.5L2.5 8 7 12.5",
  arrowRight: "M3 8h10M9 3.5 13.5 8 9 12.5",
  arrowUp: "M8 13V3M3.5 7 8 2.5 12.5 7",
  arrowDown: "M8 3v10M3.5 9 8 13.5 12.5 9",
  arrowUpRight: "M5 11 11 5M6 4.5h5.5V10",
  arrowDownLeft: "M11 5 5 11M10 11.5H4.5V6",
  close: "M4 4l8 8M12 4l-8 8",
  plus: "M8 3v10M3 8h10",
  minus: "M3 8h10",
  check: "M3 8.5 6.5 12 13 4.5",
  checkCircle: "M5.5 8.2 7.3 10l3.2-3.6M8 14.25A6.25 6.25 0 1 0 8 1.75a6.25 6.25 0 0 0 0 12.5Z",
  alert: "M8 5v3.5M8 11h.01M8 14.25A6.25 6.25 0 1 0 8 1.75a6.25 6.25 0 0 0 0 12.5Z",
  info: "M8 7.25v4M8 5h.01M8 14.25A6.25 6.25 0 1 0 8 1.75a6.25 6.25 0 0 0 0 12.5Z",
  warning: "M8 6v3M8 11.5h.01M7.1 2.5 1.8 12a1 1 0 0 0 .9 1.5h10.6a1 1 0 0 0 .9-1.5L8.9 2.5a1 1 0 0 0-1.8 0Z",
  search: "M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10Zm3.6-1.4L14 14",
  more: "M3.5 8h.01M8 8h.01M12.5 8h.01",
  refresh: "M13 3v3.5H9.5M3 13V9.5h3.5M12.5 6.5A5 5 0 0 0 3.6 5.5m-.1 4a5 5 0 0 0 8.9 1",
  undo: "M3 3v3.5h3.5M3.5 6.5A5 5 0 1 1 3 10",
  pencil: "M10.5 2.5l3 3L6 13H3v-3l7.5-7.5Z",
  trash: "M2.5 4h11M6 4V2.5h4V4m-6 0 .6 9.5h6.8L12 4",
  lock: "M4.5 7V5a3.5 3.5 0 0 1 7 0v2M3.5 7h9v6.5h-9V7Z",
  pin: "M6 2h4l-.5 4 2.5 2.5v1H4v-1L6.5 6 6 2Zm2 7.5V14",
  unpin: "M6 2h4l-.5 4 2.5 2.5v1H4v-1L6.5 6 6 2Zm2 7.5V14M2 2l12 12",
  upload: "M8 10.5V2.5M4.5 6 8 2.5 11.5 6M2.5 10.5v3h11v-3",
  download: "M8 2.5v8M4.5 7 8 10.5 11.5 7M2.5 10.5v3h11v-3",
  send: "M14 2 7 9M14 2l-4.5 12L7 9 2 6.5 14 2Z",
  play: "M5 3.5v9l7.5-4.5L5 3.5Z",
  share: "M8 10V2.5M5 5.5l3-3 3 3M3.5 8v5.5h9V8",
  paperclip: "M13 7.5 8 12.5a3 3 0 0 1-4.3-4.3l5.5-5.5a2 2 0 0 1 2.8 2.8L6.6 10.9a1 1 0 0 1-1.4-1.4L10 4.7",
  mail: "M2 4h12v8.5H2V4Zm0 .5L8 9l6-4.5",
  phone: "M5.5 2H3a1 1 0 0 0-1 1.1A11 11 0 0 0 12.9 14a1 1 0 0 0 1.1-1v-2.5l-3-1-1.5 1.5a8 8 0 0 1-4.5-4.5L6.5 5l-1-3Z",
  message: "M2 3h12v8H6l-3 2.5V11H2V3Z",
  lightbulb: "M6.25 12.25h3.5M6.75 14.25h2.5M8 1.75a4.25 4.25 0 0 0-2.4 7.76c.38.27.65.66.65 1.12v.37h3.5v-.37c0-.46.27-.85.65-1.12A4.25 4.25 0 0 0 8 1.75Z",
  mic: "M8 1.5a2 2 0 0 0-2 2V8a2 2 0 0 0 4 0V3.5a2 2 0 0 0-2-2ZM4 7.5a4 4 0 0 0 8 0M8 11.5V14",
  hash: "M6 2 5 14m6-12-1 12M2.5 5.5h11m-11 5h11",
  file: "M9 1.5H4v13h8V4.5l-3-3Zm0 0v3h3",
  fileText: "M9 1.5H4v13h8V4.5l-3-3Zm0 0v3h3M6 8.5h4M6 11h4",
  image: "M2.5 2.5h11v11h-11v-11Zm0 8 3-3 5 5M9.5 6.5h.01",
  clock: "M8 4.5V8l2.5 1.5M8 14.25A6.25 6.25 0 1 0 8 1.75a6.25 6.25 0 0 0 0 12.5Z",
  calendar: "M2.5 3.5h11v10h-11v-10ZM2.5 6.5h11M5.5 2v3M10.5 2v3",
  eye: "M1.5 8S4 3.5 8 3.5 14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8Zm6.5 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  home: "M2.5 7 8 2.5 13.5 7v6.5h-11V7Zm4 6.5v-4h3v4",
  mapPin: "M8 14.5s4.5-4.2 4.5-7.7a4.5 4.5 0 0 0-9 0c0 3.5 4.5 7.7 4.5 7.7ZM8 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
  restore: "M5.5 2.5h8v8M2.5 5.5h8v8h-8v-8Z",
  maximize: "M9.5 2.5h4v4M6.5 13.5h-4v-4M13.5 2.5 9 7M2.5 13.5 7 9",
  sizeFull: "M1.5 3h13v10h-13V3Zm2 2h9v6h-9V5Z",
  sizeLarge: "M1.5 3h13v10h-13V3Zm3.5 2h6v4.5H5V5Z",
  sizeCompact: "M1.5 3h13v10h-13V3Zm4.75 2h3.5v3h-3.5V5Z",
  zoomIn: "M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10Zm3.6-1.4L14 14M7 5v4M5 7h4",
  zoomOut: "M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10Zm3.6-1.4L14 14M5 7h4",
  list: "M5.5 4h8M5.5 8h8M5.5 12h8M2.5 4h.01M2.5 8h.01M2.5 12h.01",
  code: "M5.5 4.5 2 8l3.5 3.5M10.5 4.5 14 8l-3.5 3.5",
  database: "M2.5 3.5c0-1.1 2.5-2 5.5-2s5.5.9 5.5 2-2.5 2-5.5 2-5.5-.9-5.5-2Zm0 0v9c0 1.1 2.5 2 5.5 2s5.5-.9 5.5-2v-9M2.5 8c0 1.1 2.5 2 5.5 2s5.5-.9 5.5-2",
  chart: "M2.5 13.5h11M4.5 11V8M8 11V4M11.5 11V6.5",
  grid: "M2.5 2.5h4.5v4.5H2.5V2.5Zm6.5 0h4.5v4.5H9V2.5ZM2.5 9h4.5v4.5H2.5V9ZM9 9h4.5v4.5H9V9Z",
  truck: "M1.5 4h8v7h-8V4Zm8 2.5h3l2 2.5V11h-5M4.5 13a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm7 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
  link: "M6.5 9.5l3-3M7 4.5l1-1a2.5 2.5 0 0 1 3.5 3.5l-1 1M9 11.5l-1 1A2.5 2.5 0 0 1 4.5 9l1-1",
  copy: "M5.5 5.5h8v8h-8v-8ZM10.5 5.5v-3h-8v8h3",
  history: "M2 2.5V6h3.5M2.4 6A6 6 0 1 1 2 8.5M8 5v3l2 1.5",
  sidebar: "M2.5 3h11v10h-11V3Zm4 0v10",
  users: "M6 7.33a2.67 2.67 0 1 0 0-5.33 2.67 2.67 0 0 0 0 5.33ZM1.33 14v-1.33A2.67 2.67 0 0 1 4 10h4M11.33 6.67a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM14.67 14v-1.33a2 2 0 0 0-2-2h-1.34",
  briefcase: "M3.5 5h9c.7 0 1.25.55 1.25 1.25v6c0 .7-.55 1.25-1.25 1.25h-9c-.7 0-1.25-.55-1.25-1.25v-6C2.25 5.55 2.8 5 3.5 5ZM6 5V3.5c0-.4.35-.75.75-.75h2.5c.4 0 .75.35.75.75V5M5.4 7.1v1.4M10.6 7.1v1.4M8.55 7.1 7.95 8.85M5.25 10.6c1.85.7 3.65.7 5.5 0",
  connections: "M5 .75v2M11 .75v2M8.75 6.4 8.1 8.2M5.1 9.75c1.95.75 3.85.75 5.8 0M3.5 4.75h9c.7 0 1.25.55 1.25 1.25v2.75a3.5 3.5 0 0 1-3.5 3.5h-4.5a3.5 3.5 0 0 1-3.5-3.5V6c0-.7.55-1.25 1.25-1.25ZM8 12.25v3"
} as const;
export type GlyphName = keyof typeof GLYPH_PATHS;
export const GLYPH_NAMES = Object.keys(GLYPH_PATHS) as GlyphName[];
export function Glyph({
  name,
  className,
  ...props
}: Omit<SVGProps<SVGSVGElement>, "name"> & {
  name: GlyphName;
}) {
  return <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden className={cn("h-4 w-4 shrink-0", className)} {...props} data-sentry-element="svg" data-sentry-component="Glyph" data-sentry-source-file="Glyph.tsx">
            <path d={GLYPH_PATHS[name]} data-sentry-element="path" data-sentry-source-file="Glyph.tsx" />
        </svg>;
}